import type { ResultsViewProps } from '../../engine/types';
import type { HsaSavingsValues } from './config';
import type { HsaSavingsResult } from './calculate';
import { BarChart, formatDollarPrecise } from './BarChart';
import { ResetButton } from './ResetButton';

export function HsaSavingsResultsView({ result, reset }: ResultsViewProps<HsaSavingsValues, HsaSavingsResult>) {
  return (
    <div className="hsab-calc-savings__results">
      <div className="hsab-calc-savings__action-row">
        <ResetButton onClick={reset} />
      </div>

      <BarChart result={result} />

      {result.noSavings && (
        <p className="hsab-calc-savings__no-savings-msg">
          The amount of average yearly medical expenses is greater than average yearly contributions, so no savings
          will accumulate.
        </p>
      )}

      <div className="hsab-calc-savings__totals">
        <div className="hsab-calc-savings__total-block">
          <div className="hsab-calc-savings__total-label">
            *Tax-Savings on
            <br />
            Tax-Deferred Growth:
          </div>
          <div className="hsab-calc-savings__total-value">{formatDollarPrecise(result.taxSavings)}</div>
        </div>
        <div className="hsab-calc-savings__total-block">
          <div className="hsab-calc-savings__total-label">
            Future Value of Your
            <br />
            Health Savings Account:
          </div>
          <div className="hsab-calc-savings__total-value">{formatDollarPrecise(result.totalSavings)}</div>
        </div>
      </div>

      {/* 2026-10-08: footnote moved out of the calculator into a separate Text
          component on the page (content team), so it isn't shown twice. Kept to restore. */}
      {/*
      <p className="hsab-calc-savings__footnote">
        *Estimate of potential income tax savings from HSA contributions and earnings.
      </p>
      */}
    </div>
  );
}
